<template>
<div>
	<header class="ArticleMainHeader">
    <h1 class="ArticleMainTitle">เกี่ยวกับ เทมเพลต</h1>
  </header>
  <div class="MarkdownContent hidden-sm-and-down" style="width: 70vw;">


<v-layout row wrap>
      <v-flex xl3 lg3 md3 style="text-align: center;">
    <div style="text-align: center;">
      <img src="/static/bot component/about video.gif" style="width: 170px;" />
    </div>
  </v-flex>
        <v-flex xl9 lg9 md9 style="text-align: left;">
      <br>
      <br>
      <p class="preindent" style="width: 70%; margin-top: 100px;">เทมเพลต(Template) เป็น รูปแบบการส่งข้อความรูปแบบหนึ่งที่ผู้ใช้งานบอท สามารถกำหนดรูปแบบและจัดการเพื่อให้เหมาะสมกับงานได้มากขึ้น โดยมีรูปแบบโครงสร้างหลักๆดังนี้ หัวข้อ(title), รายละเอียด(detail), รูปภาพ(image) และ ปุ่มเมนู(choice)
      </p>
  </v-flex>
  <v-flex xl3 lg3 md3 style="text-align: center;">
    <div style="text-align: center;">
      <!-- <img src="/static/bot component/about video.gif" style="width: 90%;" /> -->
      <h3 style="margin-top: 100px;"><u>ส่วนประกอบของเทมเพลต</u></h3>
    </div>
  </v-flex>
  <v-flex xl9 lg9 md9 style="text-align: left;">
    <img src="/static/bot component/component2.jpg" style="width:  400px;" />

  </v-flex>
</v-layout>
</div>

<div class="MarkdownContent hidden-md-and-up">
      <p class="preindent">เทมเพลต(Template) เป็น รูปแบบการส่งข้อความรูปแบบหนึ่งที่ผู้ใช้งานบอท สามารถกำหนดรูปแบบและจัดการเพื่อให้เหมาะสมกับงานได้มากขึ้น โดยมีรูปแบบโครงสร้างหลักๆดังนี้ หัวข้อ(title), รายละเอียด(detail), รูปภาพ(image) และ ปุ่มเมนู(choice)</p>
    </div>

<div style="text-align: center;" class="hidden-md-and-up">
      <img src="/static/bot component/about video.gif" style="width: 70vw;" />
    </div>

<div class="hidden-md-and-up">
    <h3><u>ส่วนประกอบของเทมเพลต</u></h3>
    <img src="/static/bot component/component2.jpg" style="width:  80vw;" />
  </div>


  <header class="EndpointHeader">
    <h2 class="EndpointTitle"> API ส่งเทมเพลต </h2>
    -
    <span class="EndpointVerbPost"> POST </span>
    <span class="EndpointUrl">
      {{urlsendTemplate}}
      <v-icon class="urlcopymessage" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlsendTemplate">file_copy</v-icon>
    </span>
  </header>

  <div class="MarkdownContent hidden-sm-and-down">
      <h3>Request Header</h3>
      <code class="codecolor">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
    <h3>Request Parameter (JSON)</h3>
    <code class="codecolor">
      <v-tooltip top>
        <v-btn flat icon type="button" style="float: right;" slot="activator" class="requestmessage" v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
        <span>Copy to clipboard</span>
      </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"type"</span> : <span class="colorvalue">"template"</span>,
    <span class="colorkey">"custom_notification"</span> : <span class="colorvalue">"เปิดอ่านข้อความใหม่จากทางเรา"</span>,
    <span class="colorkey">"elements"</span> : [
      {
        <span class="colorkey">"image"</span> : <span class="colorvalue">"https://onechat.one.th/xxxxxxxxxxx.jpg"</span>,
        <span class="colorkey">"title"</span> : <span class="colorvalue">"Pizza"</span>,
        <span class="colorkey">"detail"</span> : <span class="colorvalue">"Pizza ถาดกลาง 250฿"</span>,
        <span class="colorkey">"choice"</span> : [ {....รูปแบบปุ่มต่างๆ....} ]
      },
      ...
    ]
  }
    </code>

    <table id="apimsgtable" style="margin-top: 2vh;">
      <tr>
        <th>คีย์ (Key)</th>
        <th>ประเภท (Type)</th>
        <th>จำเป็น (Required)</th>
        <th>คำอธิบาย (Description)</th>
      </tr>
      <tr>
        <td>to</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>user_id หรือ group_id ที่ต้องการจะส่ง</td>
      </tr>
      <tr>
        <td>bot_id</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>รหัสเฉพาะของบอท</td>
      </tr>
      <tr>
        <td>type</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>ประเภทของข้อความ ในที่นี้เป็น template</td>
      </tr>
       <tr>
          <td>custom_notification</td>
          <td>String</td>
          <td></td>
          <td>ข้อมูลสำหรับแสดงการแจ้งเตือน</td>
        </tr>
      <tr>
        <td>elements</td>
        <td>List [length<=10]</td>
        <td style="text-align: center;">✅</td>
        <td>ข้อมูลแต่ละ template ซึ่งจะประกอบด้วยข้อมูลที่เป็น Dictionary(json) ดังนี้
          <ul>
            <li>image คือ ลิงก์ของรูปภาพ <u><i>ระบุหรือไม่ก็ได้</i></u> </li>
            <li>title คือ หัวข้อ เป็นString [length<=80]</li>
            <li>detail คือ รายละเอียด เป็นString [length<=400]</li>
            <li>choice เป็น List [length<=4] ของ Dictionary(json) สำหรับกำหนดรูปแบบของปุ่มเมนูในเทมเพลต</li>
          </ul>
        </td>
      </tr>
    </table>
  </div>


  <div class="hidden-md-and-up">
      <h3>Request Header</h3>
      <code class="codecolormo">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <h3>Request Parameter (JSON)</h3>
    <code class="codecolormo" style="">
      <v-tooltip top >
        <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
              <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
               <span>Copy to clipboard</span>
            </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"type"</span> : <span class="colorvalue">"template"</span>,
    <span class="colorkey">"custom_notification"</span> : <span class="colorvalue">"เปิดอ่านข้อความใหม่จากทางเรา"</span>,
    <span class="colorkey">"elements"</span> : [
      {
        <span class="colorkey">"image"</span> : <span class="colorvalue">"https://onechat.one.th/xxxxxxxxxxx.jpg"</span>,
        <span class="colorkey">"title"</span> : <span class="colorvalue">"Pizza"</span>,
        <span class="colorkey">"detail"</span> : <span class="colorvalue">"Pizza ถาดกลาง 250฿"</span>,
        <span class="colorkey">"choice"</span> : [ {....รูปแบบปุ่มต่างๆ....} ]
      },
      ...
    ]
  }
    </code>

      <!-- <h3>รายละเอียดข้อมูลที่ใช้ในการส่งไฟล์</h3> -->
      <table id="apimsgtablemo" style="margin-top: 2vh;">
       <tr>
        <th>คีย์ (Key)</th>
        <th>ประเภท (Type)</th>
        <th>จำเป็น (Required)</th>
        <th>คำอธิบาย (Description)</th>
      </tr>
      <tr>
        <td>to</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>user_id หรือ group_id ที่ต้องการจะส่ง</td>
      </tr>
      <tr>
        <td>bot_id</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>รหัสเฉพาะของบอท</td>
      </tr>
      <tr>
        <td>type</td>
        <td>String</td>
        <td style="text-align: center;">✅</td>
        <td>ประเภทของข้อความ ในที่นี้เป็น template</td>
      </tr>
       <tr>
          <td>custom_notification</td>
          <td>String</td>
          <td></td>
          <td>ข้อมูลสำหรับแสดงการแจ้งเตือน</td>
        </tr>
      <tr>
        <td>elements</td>
        <td>List [length<=10]</td>
        <td style="text-align: center;">✅</td>
        <td>ข้อมูลแต่ละ template ซึ่งจะประกอบด้วยข้อมูลที่เป็น Dictionary(json) ดังนี้
          <ul>
            <li>image คือ ลิงก์ของรูปภาพ <u><i>ระบุหรือไม่ก็ได้</i></u> </li>
            <li>title คือ หัวข้อ เป็นString [length<=80]</li>
            <li>detail คือ รายละเอียด เป็นString [length<=400]</li>
            <li>choice เป็น List [length<=4] ของ Dictionary(json) สำหรับกำหนดรูปแบบของปุ่มเมนูในเทมเพลต</li>
          </ul>
        </td>
      </tr>
      </table>
    </div>

  <br>
    รูปแบบและประเภทของปุ่ม
  <ul v-if="path == '/develop/docs/template/abouttemplate'">
    <li><a  @click="toPage('/develop/docs/template/template_message')">ประเภทข้อความ</a></li>
    <li><a  @click="toPage('/develop/docs/template/template_link')">ประเภทลิงก์</a></li>
    <li><a  @click="toPage('/develop/docs/template/template_webview')">ประเภทเว็บวิว</a></li>
    <li><a  @click="toPage('/develop/docs/template/template_file')">ประเภทไฟล์</a></li>
  </ul>
  <ul v-else>
    <li><a  @click="toPage('/docs/template/template_message')">ประเภทข้อความ</a></li>
    <li><a  @click="toPage('/docs/template/template_link')">ประเภทลิงก์</a></li>
    <li><a  @click="toPage('/docs/template/template_webview')">ประเภทเว็บวิว</a></li>
    <li><a  @click="toPage('/docs/template/template_file')">ประเภทไฟล์</a></li>
  </ul>
<br>

</div>

</template>
<script>
export default {
  data: () => ({
    path: '',
    urlsendTemplate: '',
    message: '{\n\t"to": "U5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"bot_id": "Ba521xx18350a5xxx2bxxxxx",\n\t"type": "template",\n\t"custom_notification": "เปิดอ่านข้อความใหม่จากทางเรา",\n\t"elements": [\n\t\t{\n\t\t\t"image": "https://onechat.one.th/xxxxxxxxxxx.jpg",\n\t\t\t"title": "Pizza",\n\t\t\t"detail": "Pizza ถาดกลาง 250฿",\n\t\t\t"choice": [ {....รูปแบบปุ่มต่างๆ....} ]\n\t\t},\n\t\t...\n\t]\n}'
  }),
  methods: {
    toPage (page) {
      this.$router.push(page)
    }
  },
  created () {
    this.path = this.$router.currentRoute.path
    this.urlsendTemplate = process.env.APIimage + '/api/v1/push_message'
  }
}
</script>

<style type="text/css">
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/template/about_template.vue